import { IProfessionHobby, IProfessionSkill, IProfessionSubject, ITutorProfessionDetails } from '@wot/typings';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { updateProfile } from '../../../reducers/profileSlice';
import AddCategory from '../../ProfileSetup/containers/Profession/AddCategory';
import { toast } from 'react-toastify';

export default function Profession() {
  const dispatch = useAppDispatch();
  const { profile } = useAppSelector((state) => state.profileSlice);

  const onSaveProfession = async (
    data: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>
  ) => {
    await dispatch(updateProfile({ profession: data, status: 'under-review' })).then(() => {
      toast.success('Profession Details updated');
    });
  };
  return (
    <div className="relative max-w-5xl">
      <AddCategory edit={true} onSave={onSaveProfession} profession={profile?.profession} />
    </div>
  );
}
